import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CreditOperationModalForm from './CreditOperationModalForm';
import appConfig from '../../../config/app-config';

const { address, key } = appConfig.apis.legalApiEnv;

const FileLinkModalForm: React.FC = () => {
    const { fileId } = useParams();
    const navigate = useNavigate();
    const [row, setRow] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!fileId) return;
        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': key ?? '',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        };
        fetch(`${address}/files/${fileId}`, { headers })
            .then(res => res.json())
            .then(data => setRow(data))
            .catch(() => setRow(null))
            .finally(() => setLoading(false));
    }, [fileId]);

    if (loading) return <p className="p-4 text-sm text-gray-500">Carregando...</p>;
    if (!row) return <p className="p-4 text-sm text-red-500">Arquivo não encontrado.</p>;

    return (
        <CreditOperationModalForm
            show={true}
            row={row}
            onClose={() => navigate(-1)}
            onSaved={() => navigate('/legal/files/0/200/process/ASC/')}
        />
    );
};

export default FileLinkModalForm;
